import {useCallback, useMemo, useState} from "react";

export enum CourseTypes {
    ONLINE = 1,
    OFFLINE = 2,
    PRE_RECORDED = 3
}


export const COURSE_OPTIONS = [
    {
        label: 'online',
        value: CourseTypes.ONLINE
    },
    {
        label: 'offline',
        value: CourseTypes.OFFLINE
    },
    {
        label: 'pre-recorded',
        value: CourseTypes.PRE_RECORDED
    }
]import {useCallback, useMemo, useState} from "react";

export enum CourseTypes {
    ONLINE = 1,
    OFFLINE = 2,
    PRE_RECORDED = 3
}


export const COURSE_OPTIONS = [
    {
        label: 'online',
        value: CourseTypes.ONLINE
    },
    {
        label: 'offline',
        value: CourseTypes.OFFLINE
    },
    {
        label: 'pre-recorded',
        value: CourseTypes.PRE_RECORDED
    }
]